import React, { FC } from 'react';

import { BadgeIllustration } from 'src/general/components/BadgeIllustration/BadgeIllustration';
import { BADGE } from 'src/general/components/BadgeIllustration/BadgeIllustration.type';
import { LocationObject } from 'src/general/components/SetLocationPopup/EnterLocationScreen/SetLocation/SetLocation.types';

import { SetLocationPopupMicrocopyProps } from '../../SetLocationPopup.types';
import { EnterEmail } from '../EnterEmail/EnterEmail';
import styles from './PickupOptions.module.scss';

export type PickupOptionsProps = {
  microcopy: SetLocationPopupMicrocopyProps;
  canPickup?: boolean;
  location: LocationObject;
};

export const PickupOptions: FC<PickupOptionsProps> = ({ microcopy, canPickup, location }) => {
  const {
    titleCollection,
    descriptionCollection,
    footerText,
    titleOutOfArea,
    descriptionOutOfArea,
    emailDescription,
    pickupLocation,
    placeholder,
    submitButton,
    successMessage,
  } = microcopy;

  if (canPickup) {
    return (
      <div className={styles.container}>
        <div className={styles.deliveryOptionsWrapper}>
          <BadgeIllustration icon={BADGE.WAREHOUSE} background="none" shape="square" className={styles.warehouseImg} />
          <div className={styles.textWrapper}>
            <span className={styles.title}>{titleCollection}</span>
            <span className={styles.location}>{pickupLocation}</span>
            <span className={styles.description}>{descriptionCollection}</span>
          </div>
        </div>

        <div className={styles.lineBreak} />
        <div className={styles.footerWrapper}>
          <span>{footerText}</span>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className={styles.deliveryOptionsWrapper}>
        <BadgeIllustration icon={BADGE.AUSSIE} background="none" shape="square" className={styles.aussieImg} />
        <div className={styles.textWrapper}>
          <span className={styles.title}>{titleOutOfArea}</span>
          <span className={styles.description}>{descriptionOutOfArea}</span>
        </div>
      </div>
      <div className={styles.leftOffsetWrapper}>
        <div className={styles.emailText}>{emailDescription}</div>
        <EnterEmail
          location={location}
          placeholder={placeholder}
          submitButton={submitButton}
          successMessage={successMessage}
        />
      </div>
    </>
  );
};
